// Require a completed artwork upload on products printed from a customer's file.
(() => {
  const formSelector = 'product-info product-form form[data-type="add-to-cart-form"]';

  function validateArtwork(form, event) {
    const section = form.closest('product-info');
    const uploader = section?.querySelector('[data-ph-fieldname="Design upload"]');
    const uploaded = uploader?.querySelector('.uploadcare--widget_status_loaded, .uploadcare--widget[data-status="loaded"]');
    if (uploaded) return true;

    event.preventDefault();
    event.stopImmediatePropagation();

    let message = section.querySelector('[data-trydtf-upload-error]');
    if (!message) {
      message = document.createElement('p');
      message.dataset.trydtfUploadError = '';
      message.setAttribute('role', 'alert');
      message.style.cssText = 'color:#b42318;font-weight:600;margin:1rem 0;';
      (uploader || form).insertAdjacentElement('afterend', message);
    }
    message.textContent = uploader
      ? 'Please upload your artwork before adding this item to your cart.'
      : 'The artwork uploader is still loading. Please wait, then try again.';
    message.scrollIntoView({ block: 'center', behavior: 'smooth' });
    uploader?.querySelector('.uploadcare--widget__button_type_open')?.focus();
    return false;
  }

  // The uploader and Dawn's product form both attach their own handlers. Capture
  // the action before either can submit an item without a completed file.
  document.addEventListener('click', (event) => {
    const button = event.target.closest(`${formSelector} button[type="submit"]`);
    if (button) validateArtwork(button.form, event);
  }, true);

  document.addEventListener('submit', (event) => {
    if (event.target.matches(formSelector)) validateArtwork(event.target, event);
  }, true);
})();
